/**
 * Game centre page
 */
import React, {useState, useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import Container from "./../components/core/Container";
import GameCentreContent from "../components/gamecentre/GameCentreContent";
import GameCentreBanner from "../components/gamecentre/GameCentreBanner";
import GameCentreSchedule from "../components/gamecentre/GameCentreSchedule";
import GameCentreStandings from "../components/gamecentre/GameCentreStandings";
import GameCentreStatistics from "../components/gamecentre/GameCentreStatistics";
import Archive from "../components/gamecentre/Archive";
import {Helmet} from "react-helmet-async";
import ContentContainer from "../components/core/ContentContainer";
import {allSeasons} from "../components/utils/time";
import {useQuery} from "@tanstack/react-query";
import Loading from "../components/core/Loading";

const Gamecentre = () => {
    const {tab} = useParams();
    const navigate = useNavigate(); // Initialize navigate for updating URL
    const [activeTab, setActiveTab] = useState(tab || "schedule"); // Default to 'tab1' if no tab is specified
    const [tabContents, setTabContents] = useState(null); // Initialize tabContents as null

    const {isLoading, error, data} = useQuery({
        staleTime: Infinity,
        queryKey: ['division-gamecentre'],
        queryFn: () =>
            fetch(`${process.env.REACT_APP_BUIHA_API_URL}/division/`)
                .then((res) => res.json())
                .then((json) => {
                    let seasons = allSeasons();
                    let current_season = seasons[0].title;
                    let active_season = null;
                    let offset = 0;
                    json.forEach(division => {
                        if (active_season == null || division.season > active_season) {
                            active_season = division.season;
                        }
                    });

                    if (active_season < current_season) {
                        offset = 1;
                    }

                    return {offset: offset};
                }),
    });

    // Sync the active tab with the URL param when the URL changes (e.g., via back/forward navigation)
    useEffect(() => {
        if (tab) {
            setActiveTab(tab);
        } else {
            setActiveTab("schedule"); // Default to 'tab1' if none is provided
        }
    }, [tab]);

    if (isLoading)
        return (
            <Loading/>
        );


    if (error) return 'An error has occurred: ' + error.message;

    // Handle tab click and update the URL accordingly
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        navigate(`/gamecentre/${tab}`); // Update the URL with the new tab
    };

    if (data) return (
        <>
            <Helmet>
                <title>Gamecentre | BUIHA</title>
                <meta
                    name="description"
                    content={`The BUIHA Gamecentre provides the latest game schedules, standings, statistics, and archives for the British Universities Ice Hockey Association.`}
                />
                <link rel="canonical" href={`https://buiha.org/gamecentre`}/>
                <link rel="icon" type="image/png" href="/favicon.png"/>
            </Helmet>
            <GameCentreBanner activeTab={activeTab} handleTabClick={handleTabClick}/>

            <Container>
                <ContentContainer children={
                    <GameCentreContent activeTab={activeTab} tabContents={{
                        schedule: <GameCentreSchedule offset={data.offset}/>,
                        standings: <GameCentreStandings offset={data.offset}/>,
                        stats: <GameCentreStatistics offset={data.offset}/>,
                        // archive: <Archive />,
                        // TODO - ADD IN ARCHIVE
                    }}/>
                }
                                  extraClasses={"pt-4"}
                />
            </Container>
        </>
    );
};

export default Gamecentre;
